import { PAID_CODE } from 'site-modules/shared/components/delivery/constants';
import { isCarMax, isDriveway } from 'site-modules/shared/utils/dealer-details-utils';

export function isShowDeliveryDetails({ parentDealershipName, deliveryCode }) {
  return deliveryCode === PAID_CODE && (isCarMax(parentDealershipName) || isDriveway(parentDealershipName));
}
